import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../_services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private activeRequests = 0;
  private readonly constSubstrings: string[] = ['/other/api', '/api/data?cache-bust'];
  constructor(private loaderService: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.containsAnySubstring(req.url, this.constSubstrings)) {
      if (this.activeRequests === 0) {
        this.loaderService.showLoader()
      }
      this.activeRequests++;
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (!this.containsAnySubstring(req.url, this.constSubstrings)) {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.loaderService.hideLoader();
          }
        }
      })
    );
  }

  private containsAnySubstring(url: string, substrings: string[]): boolean {
    return substrings.some(substring => url.includes(substring));
  }
}

